export default __webpack_public_path__ + "static/media/No2.d447aadd.png";